<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6BUC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['170'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codinput" name="coddesc_codinput">{{ detail.tab1.codinput }}{{ detail.tab1.desc_codinput }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['20'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['30'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['40'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="dtework" name="dtework">{{ setDateOutput(detail.tab1.dtework) }}</div>
                  </div>
                </div>               
              </div>

              <div class="detail-block">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['50'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="coddesc_codshift" name="coddesc_codshift">{{ detail.tab1.codshift }} - {{ detail.tab1.desc_codshift }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['60'] }}</div>
                  <div class="detail-right ">
                      <div class="detail-text width-100" id="tim_sch_btw" name="tim_sch_btw">{{ detail.tab1.timin_sch }} - {{ detail.tab1.timout_sch }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['70'] }}</div>
                  <div class="detail-right">
                      <div class="detail-time" id="dteine" name="dteine">{{ setDateOutput(detail.tab1.dteine) }}</div>
                      <div class="detail-time" id="timine" name="timine">{{ detail.tab1.timine }}</div>
                      <div class="detail-time-line">-</div>
                      <div class="detail-time" id="dteoute" name="dteoute">{{ setDateOutput(detail.tab1.dteoute) }}</div>
                      <div class="detail-time" id="timoute" name="timoute">{{ detail.tab1.timoute }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['80'] }}</div>
                  <div class="detail-right">
                      <div class="detail-time" id="dtein" name="dtein">{{ setDateOutput(detail.tab1.dtein) }}</div>
                      <div class="detail-time" id="timin" name="timin">{{ detail.tab1.timin }}</div>
                      <div class="detail-time-line">-</div>
                      <div class="detail-time" id="dteout" name="dteout">{{ setDateOutput(detail.tab1.dteout) }}</div>
                      <div class="detail-time" id="timout" name="timout">{{ detail.tab1.timout }}</div>
                  </div>
                </div>
              </div>

              <div class="detail-block">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['90'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="coddesc_codshift2" name="coddesc_codshift2">{{ detail.tab1.codshift2 }} - {{ detail.tab1.desc_codshift2 }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="tim_sch_btw2" name="tim_sch_btw2">{{ detail.tab1.timin_sch2 }} - {{ detail.tab1.timout_sch2 }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['110'] }}</div>
                  <div class="detail-right">
                      <div class="detail-time" id="dteinr" name="dteinr">{{ setDateOutput(detail.tab1.dteinr) }}</div>
                      <div class="detail-time" id="timinr" name="timinr">{{ detail.tab1.timinr }}</div>
                      <div class="detail-time-line">-</div>
                      <div class="detail-time" id="dteoutr" name="dteoutr">{{ setDateOutput(detail.tab1.dteoutr) }}</div>
                      <div class="detail-time" id="timoutr" name="timoutr">{{ detail.tab1.timoutr }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['120'] }}</div>
                  <div class="detail-right">
                      <div class="detail-time" id="dtein2" name="dtein2">{{ setDateOutput(detail.tab1.dtein2) }}</div>
                      <div class="detail-time" id="timin2" name="timin2">{{ detail.tab1.timin2 }}</div>
                      <div class="detail-time-line">-</div>
                      <div class="detail-time" id="dteout2" name="dteout2">{{ setDateOutput(detail.tab1.dteout2) }}</div>
                      <div class="detail-time" id="timout2" name="timout2">{{ detail.tab1.timout2 }}</div>
                  </div>
                </div>
              </div>

              <div class="">
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['130'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100" id="coddesc_codreqst" name="coddesc_codreqst">{{ detail.tab1.codreqst }} - {{ detail.tab1.desc_codreqst }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC3']['160'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-100 txtarea-width response-full-width" id="remark" name="remark">{{ detail.tab1.remark }}</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
 
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6BUC3']['140'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
         
              <div class="detail detail-responsive">

                <div class="detail-header">
                  <div class="">{{ labels['HRES6BUC4']['10'] }}</div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRES6BUC4']['20'] }}</div>
                  <div class="detail-right" style="margin-bottom:10px;">
                      <div class="detail-text width-100" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab2.detail.codempid }} - {{ detail.tab2.detail.desc_codempid }}</div>
                  </div>
                </div>
              </div>

              <hrms-table :columns="tab2Table" 
                          :data="detail.tab2.table"
                          :searchDisp="false"
                          :tablePageDisp="false" />
                   
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES6BUC4']['0'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <hrms-calendar-work-time :codempid="detail.tab1.codempid" />
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import hrmsCalendarWorkTime from 'components/hrmsCalendarWorkTime/component'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres6bu-detail',
  props: [ 'labels', 'detail', 'toggle', 'currentDtereq', 'currentNumseq', 'currentCodempid', 'tab2Table', 'data', 'nowLang', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    hrmsCalendarWorkTime
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?66c3d082